
    <nav id="haloBar" [class.fixed-top]="checkUrl()" [class.top-nav-collapse]="!checkUrl()"
        class="navbar navbar-dark fixed-top navbar-expand-lg navbar-default">
        <div class="container">
            <div class="logo">
                <a class="navbar-brand page-scroll" routerLink="/"><img src="../../../assets/logo.png" alt="Logo"></a>
            </div>
            <button class="navbar-toggler" type="button" (click)="onclickToggle()" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse show-toogle justify-content-end" id="navbarSupportedContent">
                <ul class="navbar-nav navbar-right justify-content-end align-items-center">

                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="userService.isLoggedIn()" class="userName nav-link active">Welcome
                            {{userService.currentUser.name}}! </a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="userService.isLoggedIn() && userService.chackRole('Ads')  && !pageUrl.startsWith('/admin')"
                            class="ads" routerLink="/ads" (click)="onClickLi()">Ads</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="userService.isLoggedIn() && userService.chackRole('Admin')  && !pageUrl.startsWith('/admin')"
                            class="admin" routerLink="/admin/state/index" (click)="onClickLi(); newUrl=true">Admin</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="userService.isLoggedIn() && !pageUrl.startsWith('/admin')" class="logOut"
                            (click)="userService.logout(pageUrl); onClickLi()">Log out</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="!userService.isLoggedIn()" class="registe" routerLink="/account/registration"
                            (click)="onClickLi()">Create Account</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="!userService.isLoggedIn()" class="login" routerLink="/account/login"
                            [queryParams]="{returnUrl: pageUrl}" (click)="onClickLi()">Login</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="!pageUrl.startsWith('/ads') || pageUrl.startsWith('/ads')" class="home"
                            (click)="onClickLi(); onWebClick(); newUrl=true">ADS</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="pageUrl.startsWith('/web')" class="home" (click)="onSearchClick()">
                            <i class="glyphicon glyphicon-search" id="my-glyphicon"></i>
                        </a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="pageUrl.startsWith('/admin')" routerLink="/admin/state/index"
                            (click)="onClickLi()">לענדער</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="pageUrl.startsWith('/admin')" routerLink="/admin/city/index"
                            (click)="onClickLi()">שטעט</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="pageUrl.startsWith('/admin')" routerLink="/admin/mkm/index"
                            (click)="onClickLi()">מקומות</a>
                    </li>
                    <li routerLinkActive="active" class="nav-item">
                        <a *ngIf="pageUrl.startsWith('/admin')" routerLink="/admin/tzadikim/index"
                            (click)="onClickLi()">צדיקים</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
